import logo from '../../assets/images/logo22.png';
import {
  Warper,
  Logo,
  Title,
  ForgotDiv,
  FomrDiv,
  Label,
  ForgotPasswordImg,
} from './ForgotPassword.style';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useNavigate } from 'react-router-dom';
import { loadingSelector, setLoading } from '../../features/loading/loadingSlice';
import { useForm, Controller } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from '../../core/hooks';
import axiosInstance from '../../core/axiosInstance';
import img from './../../assets/images/loginbg.png';
import './ForgotPassword.css';
import foreign from './../../assets/images/foriegnlogo.png';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { classNames } from 'primereact/utils';

const ForgotPassword = () => {
  useEffect(() => {
    axiosInstance
      .get('/check-expired')
      .then()
      .catch((err) => {
        if (err.response.status === 400 && !err.response.license) {
          toast.error(err.response.data.message, {
            position: toast.POSITION.TOP_CENTER,
            toastId: 'uniqueId',
          });
          window.location.replace(window.location.origin + '/expired');
        }
      });
  }, []);
  const defaultValues = {
    email: '',
  };
  //selectors
  const isLoading = useAppSelector(loadingSelector);
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({ defaultValues });

  //store actions to store creadentials to the store
  const dispatch = useAppDispatch();

  //navigator to navigate to home if login sucess
  const navigate = useNavigate();

  const onSubmit = async (data: any) => {
    localStorage.setItem('email', data.email);
    dispatch(setLoading(true));
    await axiosInstance
      .post('/dashboard/send-link-reset-password', data)
      .then(() => {
        dispatch(setLoading(false));

        navigate('/resetPassword');
      })
      .catch((err) => {
        toast.error('You must select an image', {
          position: toast.POSITION.TOP_CENTER,
        });
        dispatch(setLoading(false));
      });
  };
  const getFormErrorMessage = (name: string) => {
    return (
      //@ts-ignore
      errors[`${name}`] && (
        <small className="p-error">
          {/* @ts-ignore */}
          {errors ? errors[`${name}`]?.message : null}
        </small>
      )
    );
  };

  return (
    <Warper>
      <ForgotDiv className="forgot-div">
        <div className="formContainer">
          <Logo src={logo} alt="logo" />
          <FomrDiv>
            <Title>Reset Your Password</Title>
            <div className="controllers-container" style={{ position: 'relative' }}>
              <div className="card">
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
                  <div className="p-field">
                    <Label
                      htmlFor="name"
                      className={classNames({
                        'p-error': errors[`email`],
                      })}
                    >
                      Email Adress
                    </Label>
                    <Controller
                      name="email"
                      control={control}
                      rules={{ required: '*Required' }}
                      render={({ field, fieldState }) => (
                        <InputText
                          className={classNames({
                            'p-invalid': fieldState.invalid,
                          })}
                          style={{ color: '#616161', opacity: '0.71' }}
                          type="email"
                          disabled={isLoading ? true : false}
                          id={field.name}
                          {...field}
                          placeholder="Enter Your Email"
                          autoFocus
                        />
                      )}
                    />
                    {getFormErrorMessage('email')}
                  </div>

                  <Button
                    type="submit"
                    label="Send OTP"
                    className="p-mt-2 submit-btn"
                    disabled={isLoading ? true : false}
                  ></Button>
                </form>
              </div>
            </div>
            {/* <Mask /> */}
          </FomrDiv>
        </div>
        <div className="for-logo">
          <img src={foreign} style={{ width: '8%' }} alt="logo" />
          <img src={foreign} style={{ width: '8%' }} alt="logo" />
        </div>
      </ForgotDiv>
      <ForgotPasswordImg>
        <img src={img} alt="" />
      </ForgotPasswordImg>
    </Warper>
  );
};

export default ForgotPassword;
